import * as z from "zod";

export const AgentReturnWindowContextSchema = z.object({
  evaluatedAt: z.iso.datetime(),
  agentGraceDays: z.number().int().nonnegative(),
  merchantGraceDays: z.number().int().nonnegative(),
  dates: z.array(
    z.object({
      itemId: z.string(),
      orderedOn: z.iso.datetime().optional(),
      fulfilledOn: z.iso.datetime().optional(),
      deliveredOn: z.iso.datetime().optional(),
    }),
  ),
});

export type AgentReturnWindowContext = z.infer<
  typeof AgentReturnWindowContextSchema
>;
